import { Router } from "@frui.ts/screens";
import { Modules } from "config";
import EnumRepository from "repositories/enumRepository";
import ConfirmationService from "services/confirmationService";
import EventBus from "services/eventBus";
import LocalizationService from "services/localizationService";
import NotificationService from "services/notificationService";
import SecurityService from "services/securityService";
import ListViewModel from "../../listViewModel";
import type { ScreenBase } from "@frui.ts/screens/dist";
import ExemptionReasonResponse from "entities/exemptionReasonResponse";

const navigationName = "exemption_reasons";

@Router.registerRoute({ name: Router.Self, route: navigationName })
export default class ExemptionReasonsViewModel extends ListViewModel<ExemptionReasonResponse, ScreenBase, ScreenBase> {
  readonly modelName = "exemptionReason";

  constructor(
    protected localizationService: LocalizationService,
    protected eventBus: EventBus,
    protected notificationService: NotificationService,
    protected confirmationService: ConfirmationService,
    protected repository: EnumRepository,
    protected securityService: SecurityService
  ) {
    super();
    this.navigationName = navigationName;
  }

  protected fetchData() {
    const { limit, offset } = this.pagingFilter;
    return this.repository.getAll("exemption_reasons", ExemptionReasonResponse, { limit, offset });
  }

  translate(code: string, size?: number): string {
    return this.localizationService.translateModule(Modules.timeCharges, `exemptionReasons.${code}`, size);
  }
}
